module.exports = __webpack_public_path__ + "static/media/unasaka-ryou.5be17a45.png";